import { useQuery } from "@tanstack/react-query";
import { setUrl } from ".";
import { DEFAULT_GRID_INFO } from "../Components/Clients/KendoClientGrid";
import { DisplayMsg } from "../services/toastService";
import { FetchData } from "../utils/array";
import { CLIENT_SEARCH_FILTERS } from "../constants/clientSearchFilters";

export const loadChannelPartners = async () => {
  try {
    const emptyOption = { label: "-Select-", value: "" };
    const response = await fetch(setUrl("CLIENT", "CP"));
    const json = await response.json();

    if (json?.data) {
      const channels = json.data;

      const channelPartners = channels.map((channel) => ({
        label: channel.CHANNEL_PARTNER,
        value: channel.CHANNEL_PARTNER,
      }));

      return {
        channelPartner: [emptyOption, ...channelPartners],
      };
    }
  } catch (error) {
    console.error(error);
    DisplayMsg("2", "Unable to Process the Request");
  }
};

export const useLoadClientGridData = (clientFilter, gridState) =>
  useQuery({
    queryKey: ["clientGridData", clientFilter, gridState],
    queryFn: async () => await loadClientGridData(clientFilter, gridState),
  });

export const loadClientGridData = async (clientFilter, gridState) => {
  const { currentPage } = clientFilter;
  const currentSize = gridState.pageSize ?? DEFAULT_GRID_INFO.pageSize;
  const currentSortName =
    FindGridColumn(
      CLIENT_SEARCH_FILTERS.CLIENT_COLUMNS,
      gridState.sort[0].field
    ) ?? DEFAULT_GRID_INFO.sortName;
  const currentSortOrder = gridState.sort[0].dir ?? DEFAULT_GRID_INFO.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("query", "");
    formData.append("qtype", "");

    const queryParams = new URLSearchParams({
      practiceName: clientFilter.practiceName,
      practiceEmail: clientFilter.practiceEmail,
      specialty: clientFilter.speciality,
      accountType: clientFilter.accountType,
      healthScore: clientFilter.healthScore,
      salesPerson: clientFilter.salesPerson,
      customerAccountNum: clientFilter.customerId?.value || "",
      channelPartner: clientFilter.channel,
      alert: clientFilter.alert,
      sortName: currentSortName,
      sortOrder: currentSortOrder,
      page: currentPage,
      rp: currentSize,
    }).toString();

    const response = await FetchData("Clients", "support", queryParams);

    if (response?.succeeded === true) {
      return response;
    } else if (
      response?.status === false &&
      response?.Message ===
        "Collection was modified; enumeration operation may not execute."
    ) {
    } else if (!response.succeeded) {
      return response;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

const FindGridColumn = (GridColumns, columnName) => {
  const column = GridColumns.find((item) => item.value === columnName);
  return column ? column.label : null;
};
